const config = {
    appId: '373136d6-76ac-4016-8416-c5648bc211b7',
    scopes: ['user.read', 'tasks.read', 'tasks.readwrite', 'mail.readwrite']
};
export default config;
